import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6780c57a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "NineGridMirrorInferenceRenderContainer"
};
const _hoisted_2 = {
  class: "flex justify-center"
};
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "intro mt16"
}, " 点击播放按钮，依次查看变换 1~4 的图例。看完后，请把题目图形依次执行变换 1~4， 在右侧九宫格中点出最终黑格分布；如果任意一步与原图完全相同，还要点击 PASS。 ", -1));
const _hoisted_5 = {
  key: 0,
  class: "example-area"
};
const _hoisted_6 = {
  class: "example-toolbar"
};
const _hoisted_7 = {
  class: "example-progress"
};
const _hoisted_8 = {
  class: "example-stage"
};
const _hoisted_9 = {
  key: 0,
  class: "example-card"
};
const _hoisted_10 = {
  class: "example-title"
};
const _hoisted_11 = {
  class: "example-pair"
};
const _hoisted_12 = {
  class: "grid-card"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "example-arrow"
}, "→", -1));
const _hoisted_14 = {
  class: "grid-card"
};
const _hoisted_15 = {
  key: 1,
  class: "example-placeholder"
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  key: 1
};
const _hoisted_18 = {
  key: 1,
  class: "review-examples"
};
const _hoisted_19 = {
  class: "review-example-title"
};
const _hoisted_20 = {
  class: "example-pair"
};
const _hoisted_21 = {
  class: "grid-card"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "example-arrow"
}, "→", -1));
const _hoisted_23 = {
  class: "grid-card"
};
const _hoisted_24 = {
  class: "answer-layout"
};
const _hoisted_25 = {
  class: "question-card"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "panel-title"
}, "题目原图", -1));
const _hoisted_27 = {
  class: "answer-card"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "panel-title"
}, "最终黑格分布", -1));
const _hoisted_29 = {
  class: "answer-grid"
};
const _hoisted_30 = ["disabled", "onClick"];
const _hoisted_31 = {
  key: 0,
  class: "answer-toolbar"
};
const _hoisted_32 = {
  key: 1,
  class: "answer-tip"
};
const _hoisted_33 = {
  key: 2,
  class: "review-block"
};
const _hoisted_34 = {
  class: "review-answer-row"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "review-label"
}, "正确黑格", -1));
const _hoisted_36 = {
  class: "review-answer-row"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "review-label"
}, "您的黑格", -1));
const _hoisted_38 = {
  class: "review-pass-row"
};
const _hoisted_39 = {
  key: 0
};
const _hoisted_40 = {
  key: 0,
  class: "review-answer-row"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "review-label"
}, "过程回看", -1));
const _hoisted_42 = {
  class: "steps-list"
};
const _hoisted_43 = {
  class: "step-item"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "step-title"
}, "原图", -1));
const _hoisted_45 = {
  class: "step-title"
};
const _hoisted_46 = {
  class: "review-pass-row"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_BinaryGrid = _resolveComponent("BinaryGrid");
  return $props.data ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]), _hoisted_4, !$props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
    type: "primary",
    disabled: $data.viewedCount >= 4 || $data.showingExample,
    onClick: $options.playNextExample
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.viewedCount >= 4 ? '已看完图例' : '播放图例'), 1)]),
    _: 1
  }, 8, ["disabled", "onClick"]), _createElementVNode("span", _hoisted_7, "已查看 " + _toDisplayString($data.viewedCount) + "/4", 1)]), _createElementVNode("div", _hoisted_8, [$data.currentExample ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, "变换 " + _toDisplayString($data.viewedCount), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_BinaryGrid, {
    grid: $data.currentExample.beforeGrid
  }, null, 8, ["grid"])]), _hoisted_13, _createElementVNode("div", _hoisted_14, [_createVNode(_component_BinaryGrid, {
    grid: $data.currentExample.afterGrid
  }, null, 8, ["grid"])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [$data.viewedCount < 4 ? (_openBlock(), _createElementBlock("span", _hoisted_16, "点击按钮查看下一组图例，每次显示 2 秒")) : (_openBlock(), _createElementBlock("span", _hoisted_17, "图例已全部查看完毕"))]))])])) : (_openBlock(), _createElementBlock("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.examples, (example, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "review-example-card",
      key: `review_example_${index}`
    }, [_createElementVNode("span", _hoisted_19, " 变换" + _toDisplayString(index + 1) + "：" + _toDisplayString($options.operateText($props.data.operates?.[index])), 1), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_BinaryGrid, {
      grid: example.beforeGrid
    }, null, 8, ["grid"])]), _hoisted_22, _createElementVNode("div", _hoisted_23, [_createVNode(_component_BinaryGrid, {
      grid: example.afterGrid
    }, null, 8, ["grid"])])])]);
  }), 128))])), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_hoisted_26, _createVNode(_component_BinaryGrid, {
    grid: $props.data.question
  }, null, 8, ["grid"])]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.cells, cell => {
    return _openBlock(), _createElementBlock("button", {
      key: cell,
      type: "button",
      class: _normalizeClass(["answer-cell", {
        active: $data.answerGrid[Math.floor(cell / 3)][cell % 3] === 1,
        readonly: $props.reviewMode
      }]),
      disabled: $props.reviewMode,
      onClick: $event => $options.toggleCell(cell)
    }, null, 10, _hoisted_30);
  }), 128))]), !$props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_el_button, {
    type: $data.passSelected ? 'warning' : 'default',
    onClick: $options.togglePass
  }, {
    default: _withCtx(() => [_createTextVNode(" PASS ")]),
    _: 1
  }, 8, ["type", "onClick"]), _createVNode(_component_el_button, {
    onClick: $options.clearAnswer
  }, {
    default: _withCtx(() => [_createTextVNode("清空重答")]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true), !$props.reviewMode && $data.viewedCount < 4 ? (_openBlock(), _createElementBlock("span", _hoisted_32, "请先看完 4 次图例后再作答")) : _createCommentVNode("", true)])]), $props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_hoisted_35, _createVNode(_component_BinaryGrid, {
    grid: $props.data.finalAnswer,
    compact: ""
  }, null, 8, ["grid"])]), _createElementVNode("div", _hoisted_36, [_hoisted_37, _createVNode(_component_BinaryGrid, {
    grid: $options.reviewGrid,
    compact: ""
  }, null, 8, ["grid"])]), _createElementVNode("div", _hoisted_38, [_createElementVNode("span", null, "正确 PASS：" + _toDisplayString($props.data.needPass ? 'PASS' : '不需要'), 1), $props.review ? (_openBlock(), _createElementBlock("span", _hoisted_39, "您的 PASS：" + _toDisplayString($options.reviewPass ? 'PASS' : '未点'), 1)) : _createCommentVNode("", true)]), $props.data.steps?.length ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_hoisted_41, _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_hoisted_44, _createVNode(_component_BinaryGrid, {
    grid: $props.data.question,
    compact: ""
  }, null, 8, ["grid"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.steps, (step, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "step-item",
      key: `step_${index}`
    }, [_createElementVNode("span", _hoisted_45, "变换" + _toDisplayString(index + 1), 1), _createVNode(_component_BinaryGrid, {
      grid: step,
      compact: ""
    }, null, 8, ["grid"])]);
  }), 128))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_46, [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswer), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    style: _normalizeStyle({
      color: $props.review.result ? '#27ae60' : '#e74c3c'
    })
  }, "您的答案：" + _toDisplayString($props.review.answer || '未作答'), 5)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}